import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

export const useRoute = createRouterSelector((state) => state.route);
